import { useCallback } from 'react'

import { UTILS } from '@/shared/constants'

export default function useRouting() {
  const getRouteWithId = useCallback(
    (route: string, id: string, param?: string) => {
      return route.replace(param ?? UTILS.PARAMS.ID, id)
    },
    []
  )

  return { getRouteWithId }
}
